import React from "react";
import { Button } from "./ui/button";

const Navigation = () => {
  return (
    <nav className="fixed top-0 w-full bg-black/95 backdrop-blur-sm z-50 border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="bg-white px-3 py-1.5 rounded">
              <span className="text-black font-bold text-lg">inKind</span>
            </div>
            <span className="text-white font-semibold">Capital</span>
          </div>
          
          <div className="hidden md:flex items-center gap-8">
            <a href="#calculator" className="text-gray-300 hover:text-white transition-colors">
              Calculator
            </a>
            <a href="#benefits" className="text-gray-300 hover:text-white transition-colors">
              Benefits
            </a>
          </div>
          
          <Button className="bg-[#D4A574] hover:bg-[#C39564] text-black font-semibold">
            GET IN TOUCH
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;